var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4.65789H3.88889H10.1111H11.6667L10.9373 15.7623C10.9101 16.1773 10.5655 16.5 10.1496 16.5H3.85043C3.43451 16.5 3.08992 16.1773 3.06266 15.7623L2.33333 4.65789Z",
    fill: "#F6DEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4.65789L3.06266 15.7623C3.08992 16.1773 3.43451 16.5 3.85043 16.5H10.1496C10.5655 16.5 10.9101 16.1773 10.9373 15.7623L11.6667 4.65789M2.33333 4.65789H0M2.33333 4.65789H3.88889M11.6667 4.65789H14M11.6667 4.65789H10.1111M3.88889 4.65789V3.07895C3.88889 2.20692 4.59581 1.5 5.46784 1.5H8.53217C9.40419 1.5 10.1111 2.20692 10.1111 3.07895V4.65789M3.88889 4.65789H10.1111",
    stroke: "#C00000",
    strokeWidth: 1.57895
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconEmpty);
export default __webpack_public_path__ + "static/media/delete-icon-empty.2464b38b22cb41353a2843c287259a67.svg";
export { ForwardRef as ReactComponent };